// import { io } from "socket.io-client";
// import storageManager from "../utils/storageManager";

// const SOCKET_URL = "http://157.180.121.229";

// let socket = null;

// export const getSocket = () => socket;

// export const connectSocket = () => {
//   const token = storageManager.getToken();
//   if (!token) return null;

//   if (socket?.connected) return socket;

//   socket = io(SOCKET_URL, {
//     auth: { token },
//     transports: ["websocket", "polling"],
//     reconnection: true,
//     reconnectionAttempts: 5,
//     reconnectionDelay: 2000,
//   });

//   socket.on("connect", () => {
//     console.log("Socket connected:", socket.id);
//   });

//   socket.on("connect_error", (err) => {
//     console.error("Socket connection error:", err.message);
//   });

//   socket.on("disconnect", (reason) => {
//     console.log("Socket disconnected:", reason);
//   });

//   return socket;
// };

// export const disconnectSocket = () => {
//   if (socket) {
//     socket.disconnect();
//     socket = null;
//   }
// };



import { io } from "socket.io-client";
import storageManager from "../utils/storageManager";
import { SERVER_URL } from "./api";

// Chat runs on the same back-end server as the API (live or test, per build).
const SOCKET_URL = SERVER_URL;
 
let socket = null;
 
export const getSocket = () => socket;
 
export const connectSocket = () => {
  const token = storageManager.getToken();
  
  // Debug: Check if token exists
  console.log("🔑 Token exists:", !!token);
  
  if (!token) {
    console.error("❌ No token found, cannot connect socket");
    return null;
  }
 
  // Don't create multiple connections
  if (socket?.connected) {
    console.log("✅ Socket already connected:", socket.id);
    return socket;
  }
 
  // Disconnect old socket if exists
  if (socket) {
    socket.disconnect();
  }
 
  console.log("🔌 Connecting to:", SOCKET_URL);
  
  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ["polling", "websocket"], // Start with polling
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });
 
  // Connection successful
  socket.on("connect", () => {
    console.log("✅ Socket CONNECTED successfully!");
    console.log("   Socket ID:", socket.id);
    console.log("   Transport:", socket.io.engine.transport.name);
  });
 
  // Connection error
  socket.on("connect_error", (err) => {
    console.error("❌ Socket CONNECTION ERROR:");
    console.error("   Message:", err.message);
    console.error("   Description:", err.description);
    console.error("   Context:", err.context);
  });
 
  // Disconnected
  socket.on("disconnect", (reason) => {
    console.log("⚠️ Socket DISCONNECTED");
    console.log("   Reason:", reason);
    if (reason === "io server disconnect") {
      // Server disconnected, need to reconnect manually
      socket.connect();
    }
  });
 
  // General error
  socket.on("error", (error) => {
    console.error("❌ Socket ERROR:", error);
  });
 
  // Reconnection attempt
  socket.io.on("reconnect_attempt", (attempt) => {
    console.log(`🔄 Reconnection attempt ${attempt}`);
  });
 
  // Reconnection failed
  socket.io.on("reconnect_failed", () => {
    console.error("❌ Reconnection FAILED");
  });
 
  return socket;
};
 
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("🔌 Socket disconnected manually");
  }
};